// TODO: change name to authoringReviewApi.js b/c it contains hooks but is not a hook and .js because it does not render jsx code
import useMutateApi from "../useMutateApi"

// constants
import apiEndpoints from "api/utils/apiEndpoints"
import queryKeys from "api/utils/queryKeys"

// apis
import useGetApi from "../useGetApi"
import getUrl from "api/apiMap"

// authoring studies
export const useGetAuthoringReviewMetadata = (studyId, params, queryOptions = {}) => {
  return useGetApi(
    getUrl(studyId ? `${apiEndpoints.authoring}${studyId}/authoring-review-metadata/` : null),
    queryKeys.authoringReview.metadata(
      Number(studyId),
      params?.["project-id"] ? Number(params["project-id"]) : null,
      params?.["actionitem-id"] ? Number(params["actionitem-id"]) : null
    ),
    queryOptions,
    params
  )
}

// NOTE: unlike the rest of the app, success notifications appear at the top/center of the screen instead of the top right so that when a subtask is completed the notification does not cover the "Complete review" button. To stay consistent, the success message notifications for the complete reivew and the complete approval notification also appear at the top/center of the screen.

// { id: `/${taskId}/complete/` }
export const usePostCompleteTask = () => {
  return useMutateApi({
    method: "post",
    apiEndpoint: getUrl(`${apiEndpoints.actionItems}`),
    // invalidateQueries: [queryKeys.authoringReview.all], // NOTE: not invalidating queries b/c doing so will replace the viewport with the completed screen instead of just showing the completed banner
    successMsg: {
      description: "Successfully completed task.",
      placement: "top",
    },
  })
}

// { id: `/${taskId}/subactionitem/${subtaskId}/complete/` }
export const usePostCompleteSubtask = () => {
  return useMutateApi({
    method: "post",
    apiEndpoint: getUrl(`${apiEndpoints.actionItems}`),
    invalidateQueries: [queryKeys.authoringReview.all],
    successMsg: {
      description: "Successfully completed subtask.",
      placement: "top",
    },
  })
}
